import { useEffect, useState } from 'react';

/** Retorna `value` após `delayMs` sem mudança. Helper de perf de render no client
 *  (ex.: debounce de filtro de busca sobre lista grande em memória). */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    return () => {
      clearTimeout(id);
    };
  }, [value, delayMs]);
  return debounced;
}
